import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-07a44fed"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "catalogue-item"
};
const _hoisted_2 = {
  class: "catalogue-label-content"
};
const _hoisted_3 = {
  class: "catalogue-label-info"
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  key: 0,
  class: "catalogue-chapter-children"
};
const _hoisted_6 = {
  key: 1,
  class: "catalogue-item"
};
const _hoisted_7 = {
  class: "catalogue-label-content"
};
import { NumberToChinese } from '@/utils/common';
import { ICON_MAP } from '@/utils/constance';
import CatalogueItem from './CatalogueItem.vue';
export default {
  __name: 'CatalogueItem',
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    index: {
      type: Number,
      default: 0
    }
  },
  setup(__props) {
    const isCatalog = type => type === 'CATALOG';
    const isSection = type => type === 'SECTION';
    const transformPaddingLeft = (index, num) => `${index * num}px`;
    const getClass = type => {
      if (type === 'SECTION') return {
        section: true
      };
      return {
        chapter: true
      };
    };
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");
      return isCatalog(__props.item.type) || __props.item.children && __props.item.children.length ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: _normalizeClass(["catalogue-label", getClass(__props.item.type)]),
        style: _normalizeStyle({
          paddingLeft: transformPaddingLeft(__props.item._index, isSection(__props.item.type) ? 30 : 20)
        })
      }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [!isSection(__props.item.type) ? (_openBlock(), _createElementBlock("span", _hoisted_4, " 第" + _toDisplayString(_unref(NumberToChinese)(__props.index + 1)) + "章 ", 1)) : _createCommentVNode("", true), isSection(__props.item.type) ? (_openBlock(), _createBlock(_component_el_image, {
        key: 1,
        class: "catalogue-label-image",
        src: _unref(ICON_MAP)[__props.item.type]
      }, null, 8, ["src"])) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(__props.item.name), 1)])])], 6), __props.item.children ? (_openBlock(), _createElementBlock("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.item.children, (l, index) => {
        return _openBlock(), _createBlock(CatalogueItem, {
          item: l,
          key: l.id,
          index: index
        }, {
          content: _withCtx(content => [_renderSlot(_ctx.$slots, "content", _normalizeProps(_guardReactiveProps(content)))]),
          _: 2
        }, 1032, ["item", "index"]);
      }), 128))])) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", {
        class: "catalogue-label",
        style: _normalizeStyle({
          paddingLeft: transformPaddingLeft(__props.item._index, 45)
        })
      }, [_createElementVNode("div", _hoisted_7, [_renderSlot(_ctx.$slots, "content", _normalizeProps(_guardReactiveProps(Object.assign(__props.item, {
        index: __props.index
      }))))])], 4)]));
    };
  }
};